export const it = {
  statInvoiceByYear: {
    company: "Azienda",
    name: "Fatture per anno",
    total: "Totale",
    year: "Anno",
  },
};
